import { Component, Input } from '@angular/core';

@Component({
  selector: 'sp-table-body-cell',
  standalone: false,
  templateUrl: './table-body-cell.component.html',
  styleUrls: ['./table-body-cell.component.scss']

})
export class TableBodyCellComponent {
  @Input() cell = null;
  @Input() label = null;
  @Input() main = null;
  @Input() buttons = null;
  @Input() expandRow = null;
  @Input() row = null;
  @Input() expandableTable = [];
  @Input() expanded = false;
  @Input() colspan = 1;
  @Input() title = null;
  @Input() width = null;

  constructor() {}
}